const MOBILE_BREAKPOINT = '(max-width: 1024px)';
const COARSE_POINTER_QUERY = '(hover: none), (pointer: coarse)';

export default function initMobileMenu() {
    const menu = document.querySelector('.mobile-menu');
    const navBurger = document.querySelector('.header__wrap__navburger');

    if (!menu || !navBurger) return;

    const mobileViewport = window.matchMedia(MOBILE_BREAKPOINT);
    const coarsePointer = window.matchMedia(COARSE_POINTER_QUERY);
    const makeTriggers = menu.querySelectorAll('.mobile-menu__wrap__parts__make__trigger');
    let animating = false;

    const shouldUseMobileInteraction = () => mobileViewport.matches || coarsePointer.matches;

    const slideMenuUp = (container, onComplete) => {
        container.style.height = '0px';
        container.addEventListener('transitionend', () => {
            container.classList.remove('active');
            animating = false;
            onComplete?.();
        }, { once: true });
    };

    const slideMenuDown = (container, onComplete) => {
        container.classList.add('active');
        container.style.height = 'auto';
        const height = container.clientHeight + 'px';
        container.style.height = '0px';
        setTimeout(() => {
            container.style.height = height;
        }, 0);
        container.addEventListener('transitionend', () => {
            animating = false;
            onComplete?.();
        }, { once: true });
    };

    const toggleMobileMake = (trigger) => {
        if (animating) return;

        const make = trigger.closest('.mobile-menu__wrap__parts__make');
        const models = make?.querySelector('.mobile-menu__wrap__parts__make__models');

        if (!make || !models) return;

        animating = true;

        if (make.classList.contains('active')) {
            make.classList.remove('active');
            slideMenuUp(models);
            return;
        }

        make.classList.add('active');
        slideMenuDown(models);
    };

    const closeAllMakes = () => {
        makeTriggers.forEach(trigger => {
            const make = trigger.closest('.mobile-menu__wrap__parts__make');
            const models = make?.querySelector('.mobile-menu__wrap__parts__make__models');

            if (!make || !models) return;

            make.classList.remove('active');
            models.classList.remove('active');
            models.style.height = '0px';
        });
    };

    navBurger.addEventListener('click', () => {
        document.body.classList.toggle('mobileMenuActive');
    });

    makeTriggers.forEach(trigger => {
        trigger.addEventListener('click', (event) => {
            if (!shouldUseMobileInteraction()) return;

            event.preventDefault();
            toggleMobileMake(trigger);
        });

        trigger.addEventListener('mouseenter', () => {
            if (shouldUseMobileInteraction()) return;
            if (trigger.closest('.mobile-menu__wrap__parts__make')?.classList.contains('active')) return;

            closeAllMakes();
            toggleMobileMake(trigger);
        });
    });

    const resetMenuState = () => {
        if (shouldUseMobileInteraction()) return;

        closeAllMakes();
        document.body.classList.remove('mobileMenuActive');
    };

    mobileViewport.addEventListener('change', resetMenuState);
    coarsePointer.addEventListener('change', resetMenuState);
}